import { render, staticRenderFns } from "./HomeworksOnlyDesktop.vue?vue&type=template&id=f5050378&"
import script from "./HomeworksOnlyDesktop.vue?vue&type=script&lang=js&"
export * from "./HomeworksOnlyDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports